import { AppDispatch, RootState } from 'src/store/store';
import { connect } from 'react-redux';
import { updateOpenSideMenu } from 'src/store/common-slices/sideNavSlice';
import TopNav from './TopNav';


const mapStateToProps = (state: RootState) => ({
    accessibleTools: state.Init.initData.associateDetails.accessibleTools,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id

});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    updateOpenSideMenu: (openSideMenu: boolean) => dispatch(updateOpenSideMenu(openSideMenu)),
});

export default connect(mapStateToProps, mapDispatchToProps) (TopNav);